import Backbone from 'backbone'
import $ from 'jquery'
import { SnapType } from './snap'
import { SnapGrid as GRID } from './snap'
import _ from 'lodash'
import KeyCodes from '../key-codes'

var KeyBindings = Backbone.View.extend({

  constructor: function () {
    _.bindAll(this, 'keydown', 'keyup')
    return Backbone.View.apply(this, arguments)
  },

  initialize: function (options) {
    this.canvas = options.canvas
  },

  keydown: function (e) {
    if ('value' in e.target) { return }

    if ($(e.target).attr('contenteditable')) { return }

    var f = _.isFunction(this.downers[e.which]) ? this.downers[e.which] : this[this.downers[e.which]]
    if (_.isFunction(f)) {
      e.preventDefault()
      f.apply(this, arguments)
    }
  },

  keyup: function (e) {
    if ('value' in e.target) { return }

    if ($(e.target).attr('contenteditable')) { return }

    var f = _.isFunction(this.uppers[e.which]) ? this.uppers[e.which] : this[this.uppers[e.which]]
    if (_.isFunction(f)) {
      e.preventDefault()
      f.apply(this, arguments)
    }
  },

  move: function (e, left, top) {
    if (!this._moving) {
      this._moving = true
      this.canvas.history.record()
    }

    if (this.canvas.collection.snapType === SnapType.GRID) {
      left *= GRID / 2 + 1
      top *= GRID / 2 + 1
    }

    this.canvas.selection.moveBy({
      left: left,
      top: top
    })
  },

  endMove: function (e) {
    delete this._moving
    this.canvas.$el.trigger('end:dragging')
  },

  selectAll: function (e) {
    if (e.metaKey || e.ctrlKey) {
      this.canvas.collection.forEach(this.canvas.selection.add.bind(this.canvas.selection))
      this.canvas.selection.group()
    }
  },

  remove: function (e) {
    this.canvas.removeSelected()
  },

  zKey: function (e) {
    if (e.shiftKey) {
      this.canvas.history.redo()
    } else {
      this.canvas.history.undo()
    }
  },

  undelegateEvents: function () {
    $(document).off('keydown', this.keydown)
    $(document).off('keyup', this.keyup)
  },

  delegateEvents: function () {
    $(document).on('keydown', this.keydown)
    $(document).on('keyup', this.keyup)
  },

  release: function () {
    this.undelegateEvents()
  }
})

var downers = KeyBindings.prototype.downers = {}
downers[KeyCodes.BACKSPACE] = 'remove'
downers[KeyCodes.LEFT] = _.partialRight(KeyBindings.prototype.move, -1, 0)
downers[KeyCodes.UP] = _.partialRight(KeyBindings.prototype.move, 0, -1)
downers[KeyCodes.RIGHT] = _.partialRight(KeyBindings.prototype.move, 1, 0)
downers[KeyCodes.DOWN] = _.partialRight(KeyBindings.prototype.move, 0, 1)
downers[KeyCodes.DELETE] = 'remove'
downers[KeyCodes.A] = 'selectAll'
downers[KeyCodes.Z] = 'zKey'

var uppers = KeyBindings.prototype.uppers = {}
uppers[KeyCodes.LEFT] = 'endMove'
uppers[KeyCodes.UP] = 'endMove'
uppers[KeyCodes.RIGHT] = 'endMove'
uppers[KeyCodes.DOWN] = 'endMove'

export default function (canvas) {
  return new KeyBindings({canvas: canvas})
}
